import Button from '@components/Button';
import Checkbox from '@components/Checkbox';
import Column from '@components/Column';
import Dropdown from '@components/Dropdown';
import ImageUploader from '@components/ImageUploader';
import Row from '@components/Row';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useTermCategories from '@hooks/term/useTermCategories';
import { Link } from '@router/Link';
import { useCallback } from 'react';

import useInquiryForm from './hooks/useInquiryForm';
import useInquiryTypes from './hooks/useInquiryTypes';
import styles from './styles.module.scss';

function InquiryWriteForm() {
  const inquiryTypes = useInquiryTypes();
  const {
    setInquiryTypeId, content, setContent, title, setTitle, inquiryTypeId,
    handleCreateInquiry, reset, privacy, setPrivacy, fileUrls, setFileUrls,
  } = useInquiryForm();

  const termCategories = useTermCategories('INQUIRY');

  const onUpdateType = useCallback((id: string) => {
    setInquiryTypeId(id);
    const inquiryType = inquiryTypes
      ?.find((type) => type.inquiryTypeId === id);
    setContent(inquiryType?.content || '');
  }, [inquiryTypes]);
  return (
            <Container>
                <Column fullWidth spacing={20} className={styles.container}>
                    <Column spacing={12} fullWidth>
                        <Text color={colors.gray7} fontWeight='bold' size='lg'>유형</Text>
                        <Dropdown
                            listTitle='문의 유형 선택'
                            value={inquiryTypeId}
                            onChange={onUpdateType}
                            placeholder='문의 유형을 선택해주세요'
                            options={inquiryTypes?.map((inquiryType) => ({
                              value: inquiryType.inquiryTypeId, label: inquiryType.name,
                            }))} />
                    </Column>
                    <Column spacing={12} fullWidth>
                        <Text color={colors.gray7} fontWeight='bold' size='lg'>제목</Text>
                        <TextField placeholder='제목을 입력해주세요.'
                                   maxLength={100}
                                   value={title}
                                   onChange={(e) => setTitle(e.target.value)} />
                    </Column>
                    <Column spacing={12} fullWidth>
                        <Text color={colors.gray7} fontWeight='bold' size='lg'>내용</Text>
                        <TextField placeholder='200자 이내로 내용을 입력해주세요.'
                                   value={content}
                                   onChange={(e) => setContent(e.target.value)}
                                   as='textarea'
                                   maxLength={200}
                                   showLength
                                   rows={4}
                                   />
                    </Column>
                    <Column spacing={12} fullWidth>
                        <Text color={colors.gray7} fontWeight='bold' size='lg'>사진 등록</Text>
                        <ImageUploader caption='*파일첨부는 최대 2개까지 등록가능합니다.'
                                       value={fileUrls}
                                       setValue={setFileUrls}
                                       maxLength={2}
                                       placeholder='10mb 이내의 이미지만 가능합니다.' />
                    </Column>
                    <Column fullWidth>
                        <Checkbox isChecked={privacy}
                                  onClick={() => setPrivacy(!privacy)} >
                            문의 처리를 위해 개인정보 수집·활용에 동의합니다.
                        </Checkbox>
                        {termCategories?.map((termCategory) => (
                            <Row fullWidth justify='flex-end' key={termCategory.id}>
                                <Link activityName='TermDetailActivity'
                                      activityParams={{ termCategoryId: termCategory.id }}>
                                    <TermText color={colors.gray6}
                                              fontWeight='bold' >
                                        {termCategory.title} 전문
                                    </TermText>
                                </Link>
                            </Row>
                        ))}
                    </Column>

                </Column>
                <Row spacing={8} fullWidth
                        className={styles.footer}>
                    <Button variant='secondary'
                            onClick={reset}
                            fullWidth
                            type='button'>초기화</Button>
                    <Button fullWidth
                                onClick={handleCreateInquiry} >
                        문의 등록
                    </Button>
                </Row>
            </Container>
  );
}

const Container = styled.div`
    width: 100%;
`;

const TermText = styled(Text)`
    //text-decoration: underline;
    //text-underline-offset: 3px;
    padding: 8px;
`;

export default InquiryWriteForm;
